import React, { useEffect, useState } from 'react'
import { useModal } from '../../hooks';
import LavorisService from '../../services/LavorisService';
import { useAlert } from '../../hooks/useAlert';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/combineReducer';
import { SelectedFiles } from '../../components/others/FileUploader/FileUploader.types';
import { useForm } from 'react-hook-form';
import { getErrorMessage } from '../../utils';
import { Modal } from '../../components/others/Modal';
import { Input } from '../../components/core/Input';
import { Button } from '../../components/core/Button';
import Select from '../../components/others/Select/Select';
import { PhoneNumber } from '../../utils/phoneNumber';
import SearchSelectFetch from '../../components/others/SearchFetch';
import { fetchAndFilterMoldes, fetchAndFilterPractices } from '../others/requestTurn/utils';
import { PillButton } from '../../components/others/PillButton';
import Textarea from '../../components/others/Textarea/Textarea';
import FileUpload from '../../components/others/FileUploader/FileUploader';
import { PrimaryButton } from '../../components/others/ButtonPrimary';
import { ExamDetails, MoldeDetails, PracticesPillows } from '../others/AppointmentMetadata';
import { Practice } from '../../services/TurnServices/Turns.type';
import { InputEmail } from '../../components/others/InputEmail';
import { PhoneNumber as PhoneNumberInput } from "../../components/others/PhoneNumber";
import { UpdatePersonalDataModal } from './UpdatePersonalDataModal';
import { SearchSelect } from '../../components/others/SearchSelect';
import { useSelectData } from '../../hooks/useSelectData';
import { Pillows } from '../../components/others/Pillows';
import NewRequestsMultipleApplicantsModal from './NewRequestMultipleApplicants';

const REQUEST_TURN_MODAL = 'requestTurnModal';
const MULTIPLE_REQUEST_TURN_MODAL = 'multipleRequestTurnModal';
const REQUEST_PRESTADOR_MODAL = 'requestPrestadorModal';
const UPDATE_PERSONAL_DATA_MODAL = 'updatePersonalDataModal';



//SOLICITUD UNITARIA
const NewRequestModal = (props: any) => {
    const controller = new AbortController();
    const signal = controller.signal;
    const LavorisInstance = LavorisService.getInstance();
    const { showAlert } = useAlert();
    const { openModal, isActive, closeModal } = useModal();
    const currentCompany = useSelector((state: RootState) => state.user.currentCompany || state.user.companies[0]?.id);   
    const [searchLoading, setSearchLoading] = useState<boolean>(false);
    const styles = "text-2xl text-red-500 font-bold";
    const [type, setType] = useState<string>('Postulante')
    const [searchData, setSearchData] = useState<string>('')
    const [usersFound, setUsersFound] = useState<any | any[]>(null)
    const [selectedEmployee, setSelectedEmployee] = useState<any>(null);
    const [selectedFiles, setSelectedFiles] = useState<SelectedFiles | null>(null,);
    const [requestLoading, setRequestLoading] = useState<boolean>(false);
    const [updateEmailPhoneData, setUpdateEmailPhoneData] = useState<{ email: string, phoneNumber: string, name: string }>({ email: "", phoneNumber: "", name: "", });
    const [isSubmitted, setIsSubmitted] = useState(false);


    const searchUser = async () => {
        setSearchLoading(true)
        try {
            setSelectedEmployee(null)
            const response = await LavorisInstance.CompanyServices.getCandidatesWithQuery(searchData, signal);
            const data = Array.isArray(response) ? response : response.data;
            setUsersFound(data);
            if (data.length === 1) setSelectedEmployee(data[0]);
        } catch (error) {
            console.error(error);
        } finally {
            setSearchLoading(false);
        }

    }



    const {
        register,
        handleSubmit,
        resetField,
        setValue,
        control,
        watch,
        reset,
        formState: { errors }
    } = useForm({
        mode: 'all'
    });

    const [patient, molde, exam, practicesSelected] = watch([
        'patient',
        "molde",
        "exam",
        "practicesSelected",
    ]);

    // const hasAppointInProgress = async () => {
    //     const hasActiveApp = await LavorisInstance.TurnServices.findActiveAppsByUserId(selectedEmployee.userId);
    //     if (hasActiveApp) {
    //         return true
    //     }
    //     return false;
    // };

    useEffect(() => {
        const normalizeString = (str: any) => {
            return str
                .trim()
                .replace(/\s+/g, ' ')
                .toLowerCase();
        };

        const chosenEmployee = usersFound?.find((e: any) => {
            const ename = e?.name?.split(',')[1]?.trim();
            const elastname = e?.name?.split(',')[0]?.trim();
            const efullname = `${elastname}, ${ename}`;

            const pname = patient?.split(',')[1]?.trim();
            const plastname = patient?.split(',')[0]?.trim();
            const pfullname = `${plastname}, ${pname}`;
            return normalizeString(efullname) === normalizeString(pfullname);
        });
        setSelectedEmployee(chosenEmployee);
    }, [patient]);


    ///Funciones para la carga de archivos

    const updateUploadedFiles = (files: File[]) =>
        setSelectedFiles({ ...selectedFiles, profileImages: files });

    const uploadFile = async (id: string, selectedFile: File) => {
        await LavorisInstance.TurnServices.addFile(
            { file: selectedFile },
            id,
        ).catch((e: any) => console.log(e));
    };
    /******************************************************/



    // OnSubmit
    const onSubmit = async (data: any) => {
        setRequestLoading(true);
        try {
            // const hasActiveApp = await hasAppointInProgress()
            // if (hasActiveApp) {
            //     return showAlert('El Postulante ya tiene un turno turno activo')
            // }
            const metadata = {
                exam: exam?.id,
                molde: molde?.id,
                practices: practicesSelected?.map((p: Practice) => p.id),
            };

            if (metadata.exam === undefined && metadata.molde === undefined && (metadata.practices === undefined || metadata.practices.length === 0)) {
                showAlert('Debe elegir un examen o una práctica para continuar')
                return;
            }

            const patientId = selectedEmployee && selectedEmployee !== undefined && selectedEmployee?.id
            const patientType = 'COMPANY_CANDIDATE';
            const dataToSubmit = {
                observations: data.comments,
                patientType,
                patientId,
                metadata,
            };

            const res = await LavorisInstance.TurnServices.RequestTurnService(dataToSubmit)

            if (res && selectedFiles?.profileImages[0]) {
                await uploadFile(
                    res.appointment,
                    selectedFiles.profileImages[0],
                );
            }
            props.onClose();
            return showAlert('Su solicitud fue creada correctamente, la podra visualizar en la pantalla de solicitudes')
        } catch (err) {
            showAlert(getErrorMessage({ title: 'No se pudo realizar la solicitud.', err }))
        } finally {
            setRequestLoading(false);
        }
    };



    useEffect(() => {
        if (isSubmitted) {
            setSelectedEmployee({
                ...selectedEmployee,
                email: updateEmailPhoneData.email,
                phoneNumber: updateEmailPhoneData.phoneNumber,
                name: updateEmailPhoneData.name,
            })
            setIsSubmitted(false);
        }

    }, [isSubmitted])


    return (
        <>
            <Modal
                show={props.show}
                modalTitle={props.modalTitle}
                urlTittle={props.urlTittle}
                onClose={props.onClose}
                titleStyle={styles}
            >
                <div>
                    <form className='flex flex-col gap-3' onSubmit={handleSubmit(onSubmit)}>
                        <div className='flex gap-2 justify-start align-middle w-auto'>
                            <Input
                                type='text'
                                fieldName='searchuser'
                                label='Buscar por apellido,nombre o dni'
                                register={register}
                                //required
                                style={{ width: '300px' }}
                                onChange={(e: any) => setSearchData(e.target.value)}
                            />
                            <Button
                                type='button'
                                text='Buscar'
                                className='bg-green-700 text-lg text-white h-[50px] text-center p-auto m-auto'
                                onClick={searchUser}
                                disabled={searchLoading}
                            />
                        </div>
                        {
                            usersFound?.length > 0 ? (
                                <Select
                                    fieldName="patient"
                                    styles="w-full rounded-md h-12"
                                    register={register}
                                    label={`Seleccionar ${type}`}
                                    required={true}
                                    error={errors?.patient}
                                    options={usersFound}

                                />
                            ) : usersFound?.length === 0 ? (
                                <div className='flex justify-center align-middle'>
                                    <h2>Sin resultados</h2>
                                </div>
                            ) : null
                        }
                        <div className="flex gap-4">
                            {selectedEmployee && selectedEmployee !== undefined ? (
                                <div className='flex flex-col gap-4 justify-around align-middle'>
                                    <div className='flex flex-col flex-wrap gap-2 justify-center align-middle text-center'>
                                        <span className='text-red-700 underline text-lg '>IMPORTANTE</span>
                                        <span className='text-red-700 '>Asegúrese que todos los datos esten correctos y actualizados</span>
                                    </div>
                                    <div className='flex gap-4 justify-around align-middle'>
                                        <div className="flex flex-col ">
                                            <p>Paciente:</p>
                                            <p>DNI:</p>
                                            <p>Teléfono:</p>
                                            <p>Email:</p>
                                        </div>
                                        <div>
                                            <p className="font-semibold">
                                                {selectedEmployee?.name || "N/A"}
                                            </p>
                                            <p className="font-semibold">
                                                {selectedEmployee?.DNI || "N/A"}
                                            </p>
                                            <p className="font-semibold">
                                                {PhoneNumber(selectedEmployee?.phoneNumber) || "N/A"}
                                            </p>
                                            <p className="font-semibold">
                                                {selectedEmployee?.email || "N/A"}
                                            </p>
                                        </div>
                                        <div className='mt-5'>
                                            <button
                                                type='button'
                                                className='flex justify-center align-middle text-white bg-blue-700 m-auto p-3 rounded-lg hover:bg-blue-900'
                                                onClick={() =>
                                                    openModal(UPDATE_PERSONAL_DATA_MODAL)
                                                }
                                            >Editar datos</button>
                                        </div>
                                    </div>
                                </div>
                            ) : undefined}
                        </div>
                        {
                            selectedEmployee && selectedEmployee !== undefined && (
                                <>

                                    <>
                                        <div className="my-5">
                                            <SearchSelectFetch
                                                control={control}
                                                name="molde"
                                                label="Puestos (Exámenes sugeridos)"
                                                disabled={Boolean(exam)}
                                                fetchOptions={async () => {
                                                    return fetchAndFilterMoldes(
                                                        LavorisInstance,
                                                        currentCompany || currentCompany.id,
                                                        type,
                                                    );
                                                }}
                                                propertyLabel={"name"}
                                                inputStyles="rounded w-full h-[50px]"
                                            />
                                            {molde && (
                                                <div className="my-5">
                                                    <div className="mb-6">
                                                        <PillButton
                                                            text={molde.name || molde.position.name}
                                                            onClick={() => resetField("molde")}
                                                        />
                                                    </div>
                                                    <MoldeDetails molde={molde} />
                                                </div>
                                            )}
                                        </div>
                                        <SearchSelectFetch
                                            control={control}
                                            name="exam"
                                            label="Examen"
                                            fetchOptions={async () =>
                                                LavorisInstance.ExamsMoldes.getExamsWithPracticesDataFilteredByPatientType(
                                                    type,
                                                )
                                            }
                                            propertyLabel={"name"}
                                            inputStyles="rounded w-full h-[50px]"
                                            disabled={Boolean(molde)}
                                        />
                                        {exam && (
                                            <div className="mb-6">
                                                <div className="mb-6">
                                                    <PillButton
                                                        key={`exam-${exam.id}`}
                                                        text={exam.name}
                                                        onClick={() => resetField("exam")}
                                                    />
                                                </div>
                                                <ExamDetails exam={exam} />
                                            </div>
                                        )}
                                    </>

                                    < SearchSelectFetch
                                        control={control}
                                        name="practiceSelector"
                                        label="Prácticas individuales"
                                        fetchOptions={async () => {
                                            return fetchAndFilterPractices(
                                                LavorisInstance,
                                                exam,
                                                molde,
                                                practicesSelected,
                                                type
                                            );
                                        }}
                                        propertyLabel={"name"}
                                        inputStyles="rounded w-full h-[50px]"
                                        onSelected={(data) => {
                                            const selected = practicesSelected?.length
                                                ? practicesSelected
                                                : [];
                                            setValue("practicesSelected", [...selected, data]);
                                        }}
                                    />
                                    {practicesSelected?.length >= 0 && (
                                        <PracticesPillows
                                            practices={practicesSelected}
                                            onClick={(practice: Practice) => {
                                                setValue(
                                                    "practicesSelected",
                                                    practicesSelected.filter((p: any) => p.id !== practice.id),
                                                );
                                            }}
                                        />
                                    )}


                                    <Textarea
                                        fieldName="comments"
                                        label="Comentarios"
                                        register={register}
                                        error={errors?.comments}
                                        styles="rounded w-full mb-4"
                                        rows={8}
                                    />
                                    <FileUpload
                                        label="Cargar archivo (Opcional)"
                                        updateFilesCb={updateUploadedFiles}
                                        maxFileSizeInBytes={500000}
                                        accept="image/jpeg,image/jpg,image/png,image/gif,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                    //multiple
                                    />


                                    {
                                        (!selectedEmployee.email || !selectedEmployee.phoneNumber) ?
                                            (
                                                <div className="w-52 m-auto">
                                                    <button
                                                        type="button"
                                                        className="bg-slate-500 font-bold text-white mt-3"
                                                        disabled={true}
                                                    >
                                                        El postulante elegido debe tener un email y un teléfono válido
                                                    </button>
                                                </div>
                                            )
                                            : (
                                                <div className="w-52 m-auto">
                                                    <PrimaryButton
                                                        type="submit"
                                                        text={'Solicitar turno'}
                                                        styles="bg-red-500 font-bold text-white mt-3"
                                                        disabled={requestLoading}
                                                    />
                                                </div>
                                            )
                                    }


                                </>

                            )
                        }


                    </form>
                </div>
            </Modal>


            {isActive(UPDATE_PERSONAL_DATA_MODAL) && (
                <UpdatePersonalDataModal
                    show
                    urlTittle={UPDATE_PERSONAL_DATA_MODAL}
                    onClose={() => closeModal(UPDATE_PERSONAL_DATA_MODAL)}
                    modalTitle={"Actualizar Nombre, Email o Teléfono"}
                    user={selectedEmployee}
                    setUpdateEmailPhoneData={setUpdateEmailPhoneData}
                    submit={setIsSubmitted}
                />
            )}
        </>
    )
}



const NewRequestPrestadorModal = (props: any) => {
    const controller = new AbortController();
    const signal = controller.signal;
    const LavorisInstance = LavorisService.getInstance();
    const { showAlert } = useAlert();
    const { openModal, closeModal, isActive } = useModal();
    const [searchLoading, setSearchLoading] = useState<boolean>(false);
    const styles = "text-2xl text-red-500 font-bold";
    const [type, setType] = useState<string>('Postulante')
    const [searchData, setSearchData] = useState<string>('')
    const [usersFound, setUsersFound] = useState<any | any[]>(null)
    const [selectedEmployee, setSelectedEmployee] = useState<any>(null);
    const [selectedFiles, setSelectedFiles] = useState<SelectedFiles | null>(null,);
    const [requestLoading, setRequestLoading] = useState<boolean>(false);
    const [updateEmailPhoneData, setUpdateEmailPhoneData] = useState<{ email: string, phoneNumber: string, name: string }>({ email: "", phoneNumber: "", name: "", });
    const [isSubmitted, setIsSubmitted] = useState(false);

    const searchUser = async () => {
        setSearchLoading(true)
        try {

            setSelectedEmployee(null)
            const response = await LavorisInstance.CompanyServices.getCandidatesWithQuery(searchData, signal);

            const data = Array.isArray(response) ? response : response.data;
            setUsersFound(data);
            if (data.length === 1) setSelectedEmployee(data[0]);
        } catch (error) {
            console.error(error);
        } finally {
            setSearchLoading(false);
        }

    }



    const {
        register,
        handleSubmit,
        resetField,
        setValue,
        control,
        watch,
        formState: { errors }
    } = useForm({
        mode: 'all'
    });

    const [patient] = watch(['patient'])

    // const hasAppointInProgress = async () => {
    //     const hasActiveApp = await LavorisInstance.TurnServices.findActiveAppsByUserId(selectedEmployee.userId);
    //     if (hasActiveApp) {
    //         return true
    //     }
    //     return false;
    // };

    useEffect(() => {
        const normalizeString = (str: any) => {
            return str
                .trim()                    // Eliminar espacios al inicio y al final
                .replace(/\s+/g, ' ')      // Reemplazar múltiples espacios por uno solo
                .toLowerCase();            // Convertir a minúsculas
        };

        const chosenEmployee = usersFound?.find((e: any) => {
            const ename = e?.name?.split(',')[1]?.trim();
            const elastname = e?.name?.split(',')[0]?.trim();
            const efullname = `${elastname}, ${ename}`;

            const pname = patient?.split(',')[1]?.trim();
            const plastname = patient?.split(',')[0]?.trim();
            const pfullname = `${plastname}, ${pname}`;
            return normalizeString(efullname) === normalizeString(pfullname);
        });
        setSelectedEmployee(chosenEmployee);
    }, [patient]);

    /****Funciones para la carga de archivos***/
    const updateUploadedFiles = (files: File[]) =>
        setSelectedFiles({ ...selectedFiles, profileImages: files });

    const uploadFile = async (id: string, selectedFile: File) => {
        await LavorisInstance.TurnServices.addFile(
            { file: selectedFile },
            id,
        ).catch((e: any) => console.log(e));
    };
    /******************************************************/



    // OnSubmit
    const onSubmit = async (data: any) => {
        setRequestLoading(true);
        try {
            // const hasActiveApp = await hasAppointInProgress()
            // if (hasActiveApp) {
            //     return showAlert('El Postulante ya tiene un turno turno activo')
            // }
            const patientId = selectedEmployee && selectedEmployee !== undefined && selectedEmployee?.id
            const patientType = 'COMPANY_CANDIDATE';
            const dataToSubmit = {
                observations: data.comments,
                patientType: patientType,
                patientId,
            };

            const res = await LavorisInstance.TurnServices.RequestPrestadorTurnService(dataToSubmit)

            if (res && selectedFiles?.profileImages[0]) {
                await uploadFile(
                    res.appointment,
                    selectedFiles.profileImages[0],
                );
            }
            props.onClose();
            return showAlert('Su solicitud fue creada correctamente, la podrá visualizar en la pantalla de solicitudes')
        } catch (err) {
            showAlert(getErrorMessage({ title: 'No se pudo realizar la solicitud.', err }))
        } finally {
            setRequestLoading(false);
        }
    };


    useEffect(() => {
        if (isSubmitted) {
            setSelectedEmployee({
                ...selectedEmployee,
                email: updateEmailPhoneData.email,
                phoneNumber: updateEmailPhoneData.phoneNumber,
                name: updateEmailPhoneData.name,
            })
            setIsSubmitted(false);
        }

    }, [isSubmitted])


    return (
        <>
            <Modal
                show={props.show}
                modalTitle={props.modalTitle}
                urlTittle={props.urlTittle}
                onClose={props.onClose}
                titleStyle={styles}
            >
                <div>
                    <form className='flex flex-col gap-3' onSubmit={handleSubmit(onSubmit)}>
                        <div className='flex gap-2 justify-start align-middle w-auto'>
                            <Input
                                type='text'
                                fieldName='searchuser'
                                label='Buscar por apellido,nombre o dni'
                                register={register}
                                //required
                                style={{ width: '300px' }}
                                onChange={(e: any) => setSearchData(e.target.value)}
                            />
                            <Button
                                type='button'
                                text='Buscar'
                                className='bg-green-700 text-lg text-white h-[50px] text-center p-auto m-auto'
                                onClick={searchUser}
                                disabled={searchLoading}
                            />
                        </div>
                        {
                            usersFound?.length > 0 ? (
                                <Select
                                    fieldName="patient"
                                    styles="w-full rounded-md h-12"
                                    register={register}
                                    label={`Seleccionar ${type}`}
                                    required={true}
                                    error={errors?.patient}
                                    options={usersFound}

                                />
                            ) : usersFound?.length === 0 ? (
                                <div className='flex justify-center align-middle'>
                                    <h2>Sin resultados</h2>
                                </div>
                            ) : null
                        }
                        <div className="flex gap-4">
                            {selectedEmployee && selectedEmployee !== undefined ? (
                                <div className='flex gap-4 justify-around align-middle'>
                                    <div className="flex flex-col ">
                                        <p>Paciente</p>
                                        <p>DNI</p>
                                        <p>Teléfono</p>
                                        <p>Email</p>
                                        <p>Dirección</p>
                                    </div>
                                    <div className='flex gap-4 justify-around align-middle'>
                                        <div>
                                            <p className="font-semibold">
                                                {selectedEmployee?.name || "N/A"}
                                            </p>
                                            <p className="font-semibold">
                                                {selectedEmployee?.DNI || "N/A"}
                                            </p>
                                            <p className="font-semibold">
                                                {PhoneNumber(selectedEmployee?.phoneNumber) || "N/A"}
                                            </p>
                                            <p className="font-semibold">
                                                {selectedEmployee?.email || "N/A"}
                                            </p>
                                            <p className="font-semibold">
                                                {selectedEmployee?.fullAddress || "N/A"}
                                            </p>
                                        </div>

                                        <div className='mt-5'>
                                            <button
                                                type='button'
                                                className='flex justify-center align-middle text-white bg-blue-700 m-auto p-3 rounded-lg hover:bg-blue-900'
                                                onClick={() =>
                                                    openModal(UPDATE_PERSONAL_DATA_MODAL)
                                                }
                                            >Editar datos</button>
                                        </div>
                                    </div>
                                </div>
                            ) : undefined}
                        </div>
                        {
                            selectedEmployee && selectedEmployee !== undefined && (
                                <>
                                    <div className="flex flex-col gap-1 justify-center align-middle">
                                        <label className="text-center text-xl text-red-600 font-extrabold underline">INFORMACIÓN OBLIGATORIA</label>
                                        <ul className="list-disc pl-6">
                                            <li>Ubicación actual del {type === 'Postulante' ? 'postulante' : 'empleado'} (ciudad, localidad y provincia)</li>
                                            <li>{type === 'Postulante' ? 'Examen Ingreso' : 'Examen Periódico o Egreso'}, prácticas</li>
                                        </ul>
                                    </div>

                                    <Textarea
                                        fieldName="comments"
                                        label="Comentarios"
                                        register={register}
                                        error={errors?.comments}
                                        styles="rounded w-full mb-4"
                                        rows={8}
                                    />
                                    <FileUpload
                                        label="Cargar archivo (Opcional)"
                                        updateFilesCb={updateUploadedFiles}
                                        maxFileSizeInBytes={500000}
                                        accept="image/jpeg,image/jpg,image/png,image/gif,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                    //multiple
                                    />

                                    {
                                        (!selectedEmployee.email || !selectedEmployee.phoneNumber) ?
                                            (
                                                <div className="w-52 m-auto">
                                                    <button
                                                        type="button"
                                                        className="bg-slate-500 font-bold text-white mt-3"
                                                        disabled={true}
                                                    >
                                                        El postulante elegido debe tener un email y un teléfono válido
                                                    </button>
                                                </div>
                                            )
                                            : (
                                                <div className="w-52 m-auto">
                                                    <PrimaryButton
                                                        type="submit"
                                                        text={'Solicitar turno'}
                                                        styles="bg-red-500 font-bold text-white mt-3"
                                                        disabled={requestLoading}
                                                    />
                                                </div>
                                            )
                                    }



                                </>

                            )
                        }


                    </form>
                </div>



            </Modal>
            {isActive(UPDATE_PERSONAL_DATA_MODAL) && (
                <UpdatePersonalDataModal
                    show
                    urlTittle={UPDATE_PERSONAL_DATA_MODAL}
                    onClose={() => closeModal(UPDATE_PERSONAL_DATA_MODAL)}
                    modalTitle={"Actualizar Nombre, Email o Teléfono"}
                    user={selectedEmployee}
                    setUpdateEmailPhoneData={setUpdateEmailPhoneData}
                    submit={setIsSubmitted}
                />
            )}
        </>
    )
}


const RequestTurnCandidateAppointments = () => {
    const { openModal, closeModal, isActive } = useModal();
    return (
        <div className="p-3 bg-white">
            <div className='flex items-center justify-center gap-4 align-middle my-11 mx-auto w-auto'>
                <button
                    className="flex justify-center px-6 py-2 my-3 text-white bg-gray-700  rounded-lg w-[fit-content]"
                    onClick={() => openModal(REQUEST_TURN_MODAL)}
                    title={'Rodriguez Peña 59'}
                >
                    Turno en Clínica Lavoris
                </button>
                <button
                    className="flex justify-center px-6 py-2 my-3 text-white bg-gray-700 ounded-lg w-[fit-content]"
                    onClick={() => openModal(MULTIPLE_REQUEST_TURN_MODAL)}
                    title={'Rodriguez Peña 59'}
                >
                    Turnos múltiples en Clínica Lavoris
                </button>
                <button
                    className="flex justify-center px-6 py-2 my-3 text-white bg-gray-700 rounded-lg w-[fit-content]"
                    onClick={() => openModal(REQUEST_PRESTADOR_MODAL)}
                    title={'Exámenes en el interior del país'}
                >
                    Turno en Clínica externa
                </button>
            </div>


            {isActive(REQUEST_TURN_MODAL) && (
                <NewRequestModal
                    show
                    urlTittle={REQUEST_TURN_MODAL}
                    onClose={() => closeModal(REQUEST_TURN_MODAL)}
                    modalTitle={"Solicitar turno en Lavoris postulante"}
                />
            )}
            {isActive(MULTIPLE_REQUEST_TURN_MODAL) && (
                <NewRequestsMultipleApplicantsModal
                    show
                    urlTittle={MULTIPLE_REQUEST_TURN_MODAL}
                    onClose={() => closeModal(MULTIPLE_REQUEST_TURN_MODAL)}
                    modalTitle={"Solicitar turnos múlltiples en Clínica Lavoris"}
                />
            )}
            {isActive(REQUEST_PRESTADOR_MODAL) && (
                <NewRequestPrestadorModal
                    show
                    urlTittle={REQUEST_PRESTADOR_MODAL}
                    onClose={() => closeModal(REQUEST_PRESTADOR_MODAL)}
                    modalTitle={"Solicitar turno externo postulante"}
                />
            )}

        </div>
    )
}

export default RequestTurnCandidateAppointments